import { IKnmErknmFormViolationFix } from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { ViolationFixMaterialTypesEnum } from 'APIPackage/KnmModule/enums/ViolationFixMaterialTypesEnum';

export function getAcceptedViolationFixFileFormats(fix: IKnmErknmFormViolationFix): string[] {
  const formats: string[] = [];

  fix?.type?.forEach(typeItem => {
    switch (typeItem.value?.value) {
      case ViolationFixMaterialTypesEnum.DOCUMENT:
        formats.push('.doc', '.docx', '.sig', '.pdf');
        break;
      case ViolationFixMaterialTypesEnum.PHOTO:
        formats.push('.jpeg', '.jpg', '.png');
        break;
      default:
        break;
    }
  });

  return formats;
}
